module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJIAAAAWCAYAAAArWsVAAAABLElEQVRoge3asUoDQRAG4D/ic8S95zjQHHmAa2OTJaROayuena11CEmV1geQC8I9R8atBAsfQXMaFCKGQ4fMnvwfXDHswE3xs7cL13l6fnkF0R8dWQ9A/wODRCoYJFLBIJEKBolUGAepwmU/h1+EHzvWiwlONz2fT1EdcD5q6tjmtQGz8QQzSZGd7e8UCUj8LebD7mFGo18x2pG6GE3v8HB/gV6DbnfCEMXOaEdqKkAegbLIUb7XKa424cuMp6LvIg/Sx8412lb1ecmPl3DTARLTuWhXq25tyXCATCqsxHoS2tWqIFG84guSLOH79Y2uLgLW8rVUFjcoXYqeM5mM9oj8jASsrnN42RbuHHOej6LU4W8kpCG+Txu1EoNEKhgkUsEgkQoGiVQwSKTiDXZKQEVhgLPAAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/word/wdhjtb1-4.png
// module id = 867
// module chunks = 0